<template>
  <div class="lh-navbar" id="myNavbar">
    <a
      @click="gotoPage('Product')"
      v-if="showProduct"
      :class="routeCategory == 'Product' ? 'lh-navbar-box active' : 'lh-navbar-box'"
      ><img
        :src="
          routeCategory == 'Product' ? navImg.Product.active : navImg.Product.inactive
        "
      /><br />สั่งสินค้า</a
    >
    <a
      @click="gotoPage('RedeemPoint')"
      v-if="showPoint"
      :class="routeCategory == 'Rewards' ? 'lh-navbar-box active' : 'lh-navbar-box'"
      ><img
        :src="routeCategory == 'Rewards' ? navImg.Rewards.active : navImg.Rewards.inactive"
      /><br />เช็กคะแนน</a
    >
    <a
      @click="gotoPage('Redeem')"
      v-if="showRewards"
      :class="routeCategory == 'Redeem' ? 'lh-navbar-box active' : 'lh-navbar-box'"
      ><img
        :src="routeCategory == 'Redeem' ? navImg.Redeem.active : navImg.Redeem.inactive"
      /><br />แลกของรางวัล</a
    >
    <a
      @click="gotoPage('Profile')"
      :class="routeCategory == 'Profile' ? 'lh-navbar-box active' : 'lh-navbar-box'"
      ><img
        :src="
          routeCategory == 'Profile' ? navImg.Profile.active : navImg.Profile.inactive
        "
      /><br />บัญชีของฉัน</a
    >
  </div>
</template>
<script>
export default {
  name: "Navbar",

  data() {
    return {
      routeCategory: this.$route.meta.category || "",
      showProduct:true,
      showPoint: true,
      showRewards:true,
      navImg: {
        Product: {
          inactive:
            "/assets/icon/products.svg",
          active:
            "/assets/icon/products.svg",
        },
        Profile: {
          inactive:
            "/assets/icon/account.svg",
          active:
            "/assets/icon/account.svg",
        },
        Rewards: {
          inactive:
            "/assets/icon/point.svg",
          active:
            "/assets/icon/point.svg",
        },
        Redeem: {
          inactive:
            "/assets/icon/redeem.svg",
          active:
            "/assets/icon/redeem.svg",
        },
      },
    };
  },
  mounted(){
     console.log('MOUNTED NAVBAR');
      this.$store.dispatch("checkExistedMember", {
            line_id: localStorage.getItem("line_id"),
            custId: localStorage.getItem("custId"),
            apiKey: localStorage.getItem("apiKey"),
          });
  },
  methods: {
    gotoPage(page) {
      console.log(page);
      this.$router.push({
        name: page,
        /*query: {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
        },
        */
      });
    },
  },
};
</script>
